import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=6ae9c6ba&scoped=true&"
import script from "./addUser.vue?vue&type=script&lang=js&"
export * from "./addUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae9c6ba",
  null
  
)

export default component.exports